import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/IconButton';
import MbTooltip from 'components/atoms/MbTooltip';
import Icon from 'components/atoms/Icon';
import { initChangeLoading } from '../../../modules/filter';

const useStyles = makeStyles((theme) => ({
  filterWrap: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    width: '100%',
    minHeight: 50,
    padding: '5px 15px',
    marginBottom: 20,
    backgroundColor: '#f6f6f9',
    borderRadius: '4px',
    '& > div': {
      display: 'flex',
      flexWrap: 'wrap',
      alignContent: 'space-around',
    },
  },
  childrenWrap: {
    boxSizing: 'border-box',
    '& > div': {
      display: 'flex',
      flexWrap: 'wrap',
      alignContent: 'space-around',
      alignItems: 'center',
      '& > div': {
        margin: '3px 7px 5px 0',
      },
    },
  },
  loadingWrap: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgb(255 255 255 / 0.5)',
  },
  progressRoot: {
    width: 30,
    height: 30,
    margin: '0 auto !important',
  },
  resetBtn: {
    width: 70,
    margin: '0 !important',
    marginLeft: 'auto !important',
  },
}));

const NewFilterWrap = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    handleOnReset,
    handleOnReSearch,
    children,
    subChildren,
    handleOnUpload,
    loading = false,
  } = props;

  const { loadingState } = useSelector((state) => state.filter);

  useEffect(() => {
    dispatch(initChangeLoading());
    // eslint-disable-next-line
  }, []);

  return (
    <div className={clsx('mb-FilterWrap', classes.filterWrap)}>
      <div className={classes.childrenWrap}>
        <div>{children}</div>
        <div>{subChildren}</div>
      </div>

      <div>
        {typeof handleOnUpload !== 'undefined' && (
          <IconButton onClick={handleOnUpload}>
            <Icon icon={'faUpload'} color="#4d5059" />
            {t('일괄등록')}
          </IconButton>
        )}
        {typeof handleOnReSearch !== 'undefined' && (
          <MbTooltip
            title={t('재검색')}
            className={classes.resetBtn}
            placement="right-start"
          >
            <IconButton onClick={handleOnReSearch}>
              <Icon icon="faSyncAlt" color="#4d5059" />
              {t('재검색')}
            </IconButton>
          </MbTooltip>
        )}
        {typeof handleOnReset !== 'undefined' && (
          <MbTooltip
            title={t('초기화')}
            className={classes.resetBtn}
            placement="right-start"
          >
            <IconButton onClick={handleOnReset}>
              <Icon icon={'faUndo'} color="#4d5059" />
              {t('초기화')}
            </IconButton>
          </MbTooltip>
        )}
      </div>
      {loading || loadingState.graph || loadingState.table ? (
        <div className={classes.loadingWrap}>
          <CircularProgress
            classes={{
              root: classes.progressRoot,
            }}
            size="20"
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default NewFilterWrap;
